import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./i18n/LanguageContext";
import HomePage from "./pages/HomePage";
import IdentitaPage from "./pages/IdentitaPage";
import ProdottiPage from "./pages/ProdottiPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import AttivitaPage from "./pages/AttivitaPage";
import ServiziPage from "./pages/ServiziPage";
import ContattiPage from "./pages/ContattiPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/identita" element={<IdentitaPage />} />
            <Route path="/prodotti" element={<ProdottiPage />} />
            <Route path="/prodotti/:id" element={<ProductDetailPage />} />
            <Route path="/attivita" element={<AttivitaPage />} />
            <Route path="/servizi" element={<ServiziPage />} />
            <Route path="/contatti" element={<ContattiPage />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
